import React from 'react'
import { Feedback } from 'app-principal-componentes-visuales'
import { formatDirection } from '../../../utils/ubicacionUtils'
import { capitalizeString } from '../../../utils/utils'
import './EliminarDomicilio.scss'

const EliminarDomicilio = ({ selectedDirection, openDeleteDirection, deleteDirection, isWeb } : {[ key: string ]: any }) => {
    
    const direccion = 'Confirmanos si querés eliminar el domicilio' + capitalizeString(` ${formatDirection(selectedDirection)}, ${selectedDirection.localidad}`);

    const handleCancel = () => {
        openDeleteDirection(selectedDirection)
    }

    const handleAccept = () => {
        deleteDirection(selectedDirection.id)
    }

    return (
        <div 
            className={ 
                `asistencia-eliminar-domicilio 
                ${!isWeb ? 'asistencia-eliminar-domicilio-mobile' : ''}`
            }
        >
            <Feedback
                className='feedback__button'
                bgWhite
                id="feedback-eliminar-domicilio"
                labelButtonCancel="No, volver"
                labelButtonOk="S&iacute;, eliminar"
                phoneEliminarTelefonoColor
                onClickCancel={handleCancel}
                onClickOk={handleAccept}
                parrafo={direccion}
                titulo="¿Querés eliminar este domicilio?"
                />
        </div>
    )
}

export default EliminarDomicilio